import { render, staticRenderFns } from "./hierarchyPersonListComponent.vue?vue&type=template&id=4a97e926&scoped=true&"
import script from "./hierarchyPersonListComponent.vue?vue&type=script&lang=js&"
export * from "./hierarchyPersonListComponent.vue?vue&type=script&lang=js&"
import style0 from "./hierarchyPersonListComponent.vue?vue&type=style&index=0&id=4a97e926&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a97e926",
  null
  
)

export default component.exports